import {frameBarrier, transitionBarrier} from "./animation";

export function searchForm() {
    const button = document.getElementById("suchFormButton");
    const form = document.getElementById("suchForm1");
    const input = document.getElementById("search-input-top1");

    let open = false;
    let transition = false;

    button.addEventListener("click", async () => {
        if (transition) {
            return;
        }

        transition = true;

        if (!open) {
            form.style.display = "flex";
            const w = form.getBoundingClientRect().width;

            form.style.maxWidth = "0";
            form.style.transition = "max-width 500ms ease";

            await frameBarrier();

            form.style.maxWidth = w + "px";
        } else {
            form.style.transition = "max-width 500ms ease";
            form.style.maxWidth = "0";
        }

        await transitionBarrier(form);

        open = !open;
        transition = false;

        form.style.transition = "";

        if (!open) {
            form.style.display = "";
            form.style.maxWidth = "";
        } else {
            input.focus();
        }
    });
}
